import experimentFlagsHelper from '@zola-helpers/client/dist/es/util/experimentFlagsHelper';

// Experiment Keys:
// 👇 example key (currently deprecated)
// export const EXAMPLE_FLAG = 'example-flag;
// keep for cookie value?
export const AUTH_FORM_V2 = 'auth-form-v2'; // INSPO-4327
export const RECAPTCHA_REFACTOR = 'recaptcha-refactor'; // https://newamsterdamlabs.atlassian.net/browse/CE-2186
export const SHOP_HOLIDAYS_2022 = 'holidaysShop2022'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2416
export const HOLIDAYS_2022 = 'holidays2022';
export const PAPER_SECONDARY_NAV_REDESIGN = 'paper-secondary-nav-redesign-v3'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2463
export const CORE_MWEB_POST_AUTH_NAV_V3 = 'core-mweb-post-auth-nav-v3'; // https://newamsterdamlabs.atlassian.net/browse/CE-3399
export const CORE_MWEB_POST_AUTH_NAV_V3_EXISTING = 'core-mweb-post-auth-nav-v3-existing'; // https://newamsterdamlabs.atlassian.net/browse/CE-3724
export const UNIVERSAL_SEARCH = 'universal-search-suggestions'; // https://newamsterdamlabs.atlassian.net/browse/CE-3459
export const PAPER_DGC_IN_CART = 'paper-dgc-in-cart'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-3287

const FALLBACK_VARIATIONS = {
  // 👇 example variation (currently deprecated)
  // [EXAMPLE_FLAG]: experimentFlagsHelper.createExperimentFlags(),
  [AUTH_FORM_V2]: experimentFlagsHelper.createExperimentFlags(),
  [SHOP_HOLIDAYS_2022]: experimentFlagsHelper.createExperimentFlags(),
  [RECAPTCHA_REFACTOR]: experimentFlagsHelper.createExperimentFlags(),
  [HOLIDAYS_2022]: experimentFlagsHelper.createExperimentFlags(),
  [PAPER_SECONDARY_NAV_REDESIGN]: experimentFlagsHelper.createExperimentFlags(),
  [CORE_MWEB_POST_AUTH_NAV_V3]: experimentFlagsHelper.createExperimentFlags(),
  [CORE_MWEB_POST_AUTH_NAV_V3_EXISTING]: experimentFlagsHelper.createExperimentFlags(),
  [UNIVERSAL_SEARCH]: experimentFlagsHelper.createExperimentFlags(),
  [PAPER_DGC_IN_CART]: experimentFlagsHelper.createExperimentFlags(),
};

const {
  getFlag,
  getExperimentVariation,
  isUnderTest,
  isInExperiment,
} = experimentFlagsHelper.makeExperimentFlags(FALLBACK_VARIATIONS);

export default {
  getExperimentVariation,
  isUnderTest,
  getFlag,
  isInExperiment,
};
